import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight, FiStar} = FiIcons;

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="container hero-grid">
        <div className="hero-copy">
          <span className="eyebrow">A little more you, every day</span>
          <h1>Good hair days.<br /><em>Beautifully</em> yours.</h1>
          <p>Thoughtful hair, beauty and grooming services in the heart of Lucknow. Come as you are; leave feeling your best.</p>
          <div className="hero-actions">
            <a className="button button-gold" href="#appointment">
              Book Appointment <SafeIcon icon={FiArrowRight} />
            </a>
            <a className="text-link" href="#services">Explore Services <span>↗</span></a>
          </div>
          <div className="trust-line">
            <span className="trust-stars"><SafeIcon icon={FiStar} /> 4.9</span>
            <span className="trust-divider" /> Google Rating
            <span className="trust-divider" /> 500+ Happy Clients
          </div>
        </div>
        <div className="hero-image-wrap">
          <img
            src="https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/7f03fdb997d09bce6d6b212d7a4e8c5e.webp"
            alt="Bridal makeup look"
          />
          <div className="hero-note">
            <span>01</span>
            <p>Thoughtful care.<br />Beautiful results.</p>
          </div>
        </div>
      </div>
      <div className="hero-bottom container">
        <span>LUCKNOW · UTTAR PRADESH</span>
        <span>HAIR · SKIN · MAKEUP · GROOMING</span>
      </div>
    </section>
  );
}

export default Hero;
